import React from 'react';
import { Card } from 'react-bootstrap';
import Container from 'landing-page/components/common/Container';

export const BlogDetailPlaceholder: React.FC = () => {
  return (
    <>
      {/* Breadcrumb placeholder */}
      <Container className="px-15">
        <div className="placeholder-glow d-flex align-items-center gap-2">
          <div className="placeholder bg-secondary rounded" style={{ height: 16, width: 60 }} />
          <div className="placeholder bg-secondary rounded" style={{ height: 16, width: 16 }} />
          <div className="placeholder bg-secondary rounded" style={{ height: 16, width: 40 }} />
          <div className="placeholder bg-secondary rounded" style={{ height: 16, width: 16 }} />
          <div className="placeholder bg-secondary rounded" style={{ height: 16, width: 120 }} />
        </div>
      </Container>

      {/* Title placeholder */}
      <Container className="px-15">
        <div className="placeholder-glow">
          <div className="placeholder bg-secondary rounded mb-2" style={{ height: 32, width: '80%' }} />
          <div className="placeholder bg-secondary rounded" style={{ height: 32, width: '60%' }} />
        </div>
      </Container>

      <Container className="px-15">
      <div className="row">
        <div className="col-md-8">
          <Card className="mb-5 border-0 shadow-sm rounded-4 overflow-hidden">
            <div className="bg-light" style={{ minHeight: 350 }}>
              <div className="d-flex align-items-center justify-content-center h-100 min-vh-25">
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            </div>
            <Card.Body>
              <div className="d-flex justify-content-between border-bottom pb-3 mb-3">
                <div className="placeholder-glow">
                  <div className="placeholder bg-secondary rounded" style={{ height: 20, width: 180 }} />
                </div>
                <div className="placeholder-glow">
                  <div className="placeholder bg-secondary rounded" style={{ height: 32, width: 140 }} />
                </div>
              </div>
              <div className="placeholder-glow">
                <div className="placeholder bg-secondary rounded mb-2" style={{ height: 16, width: '100%' }} />
                <div className="placeholder bg-secondary rounded mb-2" style={{ height: 16, width: '100%' }} />
                <div className="placeholder bg-secondary rounded mb-2" style={{ height: 16, width: '95%' }} />
                <div className="placeholder bg-secondary rounded mb-2" style={{ height: 16, width: '80%' }} />
                <div className="placeholder bg-secondary rounded" style={{ height: 16, width: '70%' }} />
              </div>
            </Card.Body>
          </Card>
        </div>
        <div className="col-md-4">
          <div className="placeholder-glow mb-3">
            <div className="placeholder bg-secondary rounded" style={{ height: 24, width: 140 }} />
          </div>
          {[1, 2, 3].map((i) => (
            <Card key={i} className="mb-5 border-0 shadow-sm rounded-4 overflow-hidden">
              <Card.Body>
                <div className="d-flex gap-3">
                  <div className="placeholder bg-secondary rounded" style={{ width: '35%', height: 94 }} />
                  <div className="flex-grow-1">
                    <div className="placeholder bg-secondary rounded mb-2" style={{ height: 16, width: '100%' }} />
                    <div className="placeholder bg-secondary rounded mb-2" style={{ height: 16, width: '80%' }} />
                    <div className="placeholder bg-secondary rounded" style={{ height: 14, width: 60 }} />
                  </div>
                </div>
              </Card.Body>
            </Card>
          ))}
        </div>
      </div>
      </Container>
    </>
  );
};
